(function () {
  'use strict';

  function getQuickViewButtons(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const buttons = Array.from(scope.querySelectorAll('[data-product-card-quick-view]'));
    if (scope.matches && scope.matches('[data-product-card-quick-view]')) buttons.unshift(scope);
    return buttons;
  }

  // Button colors and radius come from the Quickview section's own style block
  // (snippets/quick-view-modal.liquid); only availability is synced here.
  function syncQuickViewButtons(root) {
    const hasQuickView = Boolean(document.querySelector('[data-quick-view-modal]'));

    getQuickViewButtons(root).forEach((button) => {
      button.hidden = !hasQuickView;
      button.setAttribute('aria-hidden', hasQuickView ? 'false' : 'true');
      if (!hasQuickView) {
        button.dataset.loading = 'false';
      }
    });
  }

  function setProductCardGalleryIndex(gallery, index) {
    if (!gallery) return;
    const slides = Array.from(gallery.querySelectorAll('[data-product-card-gallery-slide]'));
    if (!slides.length) return;
    const normalized = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === normalized;
      slide.style.transform = `translate3d(${(slideIndex - normalized) * 100}%, 0, 0)`;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    gallery.querySelectorAll('[data-product-card-gallery-indicator]').forEach((indicator, indicatorIndex) => {
      indicator.classList.toggle('is-active', indicatorIndex === normalized);
    });
  }

  function initProductCardMediaGallery() {
    if (window.AxiomProductCardMediaGalleryBound) return;
    window.AxiomProductCardMediaGalleryBound = true;

    document.addEventListener('pointermove', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const gallery = event.target.closest('[data-product-card-hover-effect="media_gallery"] [data-product-card-media-gallery]');
      if (!gallery) return;
      const slides = gallery.querySelectorAll('[data-product-card-gallery-slide]');
      if (slides.length < 2) return;
      gallery._productCardPointerX = event.clientX;
      if (gallery._productCardPointerFrame) return;
      gallery._productCardPointerFrame = requestAnimationFrame(() => {
        gallery._productCardPointerFrame = null;
        const rect = gallery.getBoundingClientRect();
        if (!rect.width) return;
        const position = Math.max(0, Math.min(.9999, (gallery._productCardPointerX - rect.left) / rect.width));
        setProductCardGalleryIndex(gallery, Math.floor(position * slides.length));
      });
    });

    document.addEventListener('pointerout', (event) => {
      const gallery = event.target.closest('[data-product-card-media-gallery]');
      if (!gallery || (event.relatedTarget && gallery.contains(event.relatedTarget))) return;
      if (gallery._productCardPointerFrame) {
        cancelAnimationFrame(gallery._productCardPointerFrame);
        gallery._productCardPointerFrame = null;
      }
      setProductCardGalleryIndex(gallery, 0);
    });
  }

  function cancelProductCardGalleryFrames(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-product-card-media-gallery]').forEach((gallery) => {
      if (!gallery._productCardPointerFrame) return;
      cancelAnimationFrame(gallery._productCardPointerFrame);
      gallery._productCardPointerFrame = null;
    });
  }

  function initProductCardSwatches() {
    if (window.AxiomProductCardSwatchesBound) return;
    window.AxiomProductCardSwatchesBound = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('[data-product-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
        const active = button === swatch;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) {
        card.querySelectorAll('[data-product-card-link]').forEach((link) => {
          link.setAttribute('href', variantUrl);
          if (link.matches('[data-mobile-quick-view-trigger], [data-quick-view]')) {
            link.dataset.productUrl = variantUrl;
          }
        });
      }

      const quickViewTrigger = card.querySelector('[data-product-card-quick-view]');
      if (quickViewTrigger && swatch.dataset.productUrl) {
        quickViewTrigger.dataset.productUrl = swatch.dataset.productUrl;
      }

      const image = card.querySelector('.product-card-link img:not(.product-card-image__hover)');
      if (image && swatch.dataset.imageSrc) {
        image.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
      }

      const imageWrap = card.querySelector('.product-card-image');
      if (imageWrap && swatch.dataset.imageSrc) {
        imageWrap.classList.add('product-card-image--variant-selected');
      }

      setProductCardGalleryIndex(card.querySelector('[data-product-card-media-gallery]'), 0);

      const hoverImage = card.querySelector('.product-card-image__hover');
      if (hoverImage && swatch.dataset.imageSrc) {
        hoverImage.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) hoverImage.srcset = swatch.dataset.imageSrcset;
      }

      const price = card.querySelector('[data-product-card-price]');
      if (price && swatch.dataset.priceHtml) {
        price.innerHTML = swatch.dataset.priceHtml;
      }

      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(card, {
          productId: card.dataset.productId,
          available: swatch.dataset.variantAvailable === 'true',
          price: Number(swatch.dataset.variantPrice || 0),
          compareAtPrice: Number(swatch.dataset.variantCompareAtPrice || 0),
          purchaseOptionLabel: swatch.dataset.variantPurchaseOptionLabel || '',
        });
      }

      syncQuickBar(card, swatch);
    });
  }

  // Quick add bar on the card image (snippets/product-card-quick-bar.liquid). Its value buttons add
  // the variant with that value and the value chosen in the card's variant row.
  function quickBarVariants(bar) {
    if (bar._quickBarVariants !== undefined) return bar._quickBarVariants;
    const source = bar.querySelector('[data-product-card-quick-bar-variants]');
    let variants = null;
    try {
      variants = source ? JSON.parse(source.textContent) : null;
    } catch (error) {
      variants = null;
    }
    bar._quickBarVariants = Array.isArray(variants) ? variants : null;
    return bar._quickBarVariants;
  }

  function setQuickBarValue(button, variant) {
    const available = Boolean(variant && variant[1]);
    button.dataset.variantId = variant ? String(variant[0]) : '';
    button.dataset.quantity = variant ? String(variant[2] || 1) : '1';
    button.setAttribute('aria-label', (available ? button.dataset.labelAdd : button.dataset.labelSoldOut) || '');
    if (available) {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('tabindex');
    } else {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('tabindex', '-1');
    }
  }

  function syncQuickBar(card, swatch) {
    const bar = card.querySelector('[data-product-card-quick-bar]');
    if (!bar) return;

    // "Choose options" opens quick view (or the product page) on the chosen variant.
    const chooseLink = bar.querySelector('[data-quick-view]');
    if (chooseLink && swatch.dataset.productUrl) {
      chooseLink.setAttribute('href', swatch.dataset.productUrl);
      chooseLink.dataset.productUrl = swatch.dataset.productUrl;
    }

    // Only the swatch option to choose: the one button adds the swatch's variant.
    const variantButton = bar.querySelector('[data-product-card-quick-bar-variant]');
    if (variantButton && swatch.dataset.variantId) {
      const available = swatch.dataset.variantAvailable === 'true';
      variantButton.dataset.variantId = swatch.dataset.variantId;
      variantButton.dataset.quantity = swatch.dataset.variantQuantity || '1';
      variantButton.textContent = (available ? variantButton.dataset.textAdd : variantButton.dataset.textSoldOut) || '';
      setQuickBarValue(variantButton, [swatch.dataset.variantId, available, variantButton.dataset.quantity]);
      return;
    }

    const variants = quickBarVariants(bar);
    const cardIndex = Number(bar.dataset.cardOptionIndex);
    const barIndex = Number(bar.dataset.optionIndex);
    if (!variants || cardIndex < 0 || barIndex < 0) return;
    const selected = swatch.dataset.swatch;
    bar.querySelectorAll('[data-product-card-quick-bar-value]').forEach((button) => {
      const value = button.dataset.productCardQuickBarValue;
      const matches = variants.filter((variant) => variant[3][barIndex] === value && variant[3][cardIndex] === selected);
      setQuickBarValue(button, matches.find((variant) => variant[1]) || matches[0]);
    });
  }

  function variantUrl(productUrl, variantId) {
    if (!productUrl || !variantId) return productUrl || '';
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    return url.pathname + url.search;
  }

  function initQuickBar() {
    if (window.AxiomProductCardQuickBarBound) return;
    window.AxiomProductCardQuickBarBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-product-card-quick-bar-add]');
      if (!button) return;
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true' || button.dataset.loading === 'true') return;

      const bar = button.closest('[data-product-card-quick-bar]');
      const card = button.closest('[data-product-card]');
      const variantId = button.dataset.variantId;
      if (!bar || !variantId) return;

      // A required custom option in the Quick add section, or no cart script: the product opens
      // on that variant instead (quick view when the page has it).
      const storefront = window.AxiomStandardStorefront;
      const modal = document.querySelector('[data-quick-view-modal]');
      if (!storefront || typeof storefront.addLines !== 'function' || (modal && modal.hasAttribute('data-quick-add-requires-input'))) {
        const url = variantUrl(bar.dataset.productUrl, variantId);
        const quickView = modal && card && card.querySelector('[data-product-card-quick-view]');
        if (quickView) {
          quickView.dataset.productUrl = url;
          quickView.click();
        } else {
          window.location.href = url;
        }
        return;
      }

      const properties = {};
      if (bar.dataset.manualPreorder === 'true') properties._manual_preorder = 'true';
      if (window.AxiomAddToCartAnimation) {
        window.AxiomAddToCartAnimation.play({
          button: button,
          imageUrl: bar.dataset.atcAnimationImage || '',
          mode: 'quick'
        });
      }

      button.dataset.loading = 'true';
      button.setAttribute('aria-busy', 'true');
      bar.dataset.loading = 'true';
      setCardCartStatus(card, '');
      storefront.addLines({
        id: variantId,
        quantity: parseInt(button.dataset.quantity || '1', 10) || 1,
        properties: properties
      }, {
        target: card || button,
        source: 'product-card-quick-bar'
      }).then(function () {
        showQuickAddSuccess(bar);
      }).catch(function (error) {
        showQuickAddError(error, button, card || button);
      }).finally(function () {
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        delete bar.dataset.loading;
      });
    });
  }

  // Quick add section (sections/quickview.liquid) > Button action. "Add to cart when
  // possible" adds a product without variants at once; every other product opens quick
  // view through the [data-quick-view] handler in component-quick-view.js.
  function quickAddAction() {
    const modal = document.querySelector('[data-quick-view-modal]');
    return (modal && modal.dataset.quickAddAction) || 'quick_view';
  }

  // Direct add only when nothing has to be chosen: a required custom option in the
  // Quick add section (data-quick-add-requires-input) sends every product to quick view.
  function addsDirectly() {
    const modal = document.querySelector('[data-quick-view-modal]');
    return quickAddAction() === 'add' && !(modal && modal.hasAttribute('data-quick-add-requires-input'));
  }

  function cartString(key) {
    return String((window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || '');
  }

  // Cart type = Page has no drawer: the card shows Shopify's reason under its info
  // (role="alert" announces it). The text is set on the next frame so the alert
  // is announced again when the same message repeats.
  function setCardCartStatus(card, message) {
    const info = card && card.querySelector('.product-card-info');
    if (!info) return;
    let status = info.querySelector('[data-product-card-cart-status]');
    if (!status) {
      if (!message) return;
      status = document.createElement('p');
      status.className = 'product-card__cart-status';
      status.setAttribute('role', 'alert');
      status.setAttribute('data-product-card-cart-status', '');
      info.appendChild(status);
    }
    status.textContent = '';
    status.hidden = !message;
    if (!message) return;
    window.requestAnimationFrame(() => {
      if (status.isConnected) status.textContent = message;
    });
  }

  // One status region on <body> announces a successful quick add when no drawer opens.
  function announceQuickAdd(message) {
    let region = document.querySelector('[data-quick-add-status]');
    if (!region) {
      region = document.createElement('p');
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-atomic', 'true');
      region.setAttribute('data-quick-add-status', '');
      document.body.appendChild(region);
    }
    region.textContent = '';
    window.requestAnimationFrame(() => {
      region.textContent = message;
    });
  }

  // A refused add opens the cart drawer with Shopify's reason in its status line, where
  // the shopper looks after adding; with Cart type = Page the card shows it.
  function showQuickAddError(error, button, card) {
    const message = (error && error.message) || cartString('addError');
    const cart = window.Axiom && window.Axiom.cart;
    if (cart && typeof cart.showMessage === 'function') {
      cart.showMessage(message, button);
      return;
    }
    setCardCartStatus(card, message);
  }

  // With the drawer, the opening drawer is the confirmation. With Cart type = Page the
  // shopper stays on the page, as after Add to cart on a product page: the cart count
  // updates and the status region says what was added.
  function showQuickAddSuccess(button) {
    const cart = window.Axiom && window.Axiom.cart;
    if (cart && typeof cart.showMessage === 'function') return;
    announceQuickAdd(cartString('addedItem').replace('[product]', button.dataset.productTitle || ''));
  }

  // Every card on the page: the Quick add section can re-render on its own in the editor.
  function syncQuickAddLabels() {
    const adds = addsDirectly();
    getQuickViewButtons(document).forEach((button) => {
      let label = button.dataset.labelQuickView || '';
      if (adds) label = button.hasAttribute('data-quick-add-direct') ? button.dataset.labelAdd : button.dataset.labelChoose;
      if (!label) return;
      button.setAttribute('aria-label', label + ': ' + (button.dataset.productTitle || ''));
      button.dataset.productGridCursorLabel = label;
    });
  }

  function initQuickAdd() {
    if (window.AxiomQuickAddBound) return;
    window.AxiomQuickAddBound = true;

    // Capture phase: runs before the document-level quick view handler.
    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-product-card-quick-view][data-quick-add-direct]');
      if (!button || !addsDirectly()) return;
      const storefront = window.AxiomStandardStorefront;
      if (!storefront || typeof storefront.addLines !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.dataset.loading === 'true') return;

      const properties = {};
      if (button.dataset.manualPreorder === 'true') properties._manual_preorder = 'true';
      const card = button.closest('[data-product-card]');
      if (window.AxiomAddToCartAnimation) {
        window.AxiomAddToCartAnimation.play({
          button: button,
          imageUrl: button.dataset.atcAnimationImage || '',
          mode: 'quick'
        });
      }

      button.dataset.loading = 'true';
      setCardCartStatus(card, '');
      storefront.addLines({
        id: button.dataset.quickAddVariantId,
        quantity: parseInt(button.dataset.quickAddQuantity || '1', 10) || 1,
        properties: properties
      }, {
        target: card || button,
        source: 'product-card-quick-add'
      }).then(function () {
        showQuickAddSuccess(button);
      }).catch(function (error) {
        showQuickAddError(error, button, card || button);
      }).finally(function () {
        button.dataset.loading = 'false';
      });
    }, true);
  }

  function init(root) {
    initProductCardSwatches();
    initQuickAdd();
    if (document.querySelector('[data-product-card-quick-bar]')) initQuickBar();
    syncQuickAddLabels();
    initProductCardMediaGallery();
    syncQuickViewButtons(root);
  }

  window.AxiomProductCard = window.AxiomProductCard || {};
  window.AxiomProductCard.initialize = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    cancelProductCardGalleryFrames(event.target);
    if (event.target && event.target.querySelector && event.target.querySelector('[data-quick-view-modal]')) return;
    syncQuickViewButtons(document);
  });
  document.addEventListener('axiom:section-rendered', function (event) {
    init(event.detail && event.detail.container ? event.detail.container : event.target);
  });
  // Related products load their cards after the page (section-product-recommendations.js).
  document.addEventListener('axiom:recommendations:loaded', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-product-card-quick-bar]')) initQuickBar();
  });
})();
